import React from 'react';

import Menu from './components/Menu'
import Slide from './components/Slide'
import Nuevos from './components/Nuevos'
import Lineas from './components/Lineas'
import Marcas from './components/Marcas'
import Promo from './components/Promo'
import Quienessomos from './components/Quienessomos'
import Misvis from './components/Misvis'
import Mapa from './components/Mapa'
import Locales from './components/Locales'
import Galeria from './components/Galeria'
import Contactos from './components/Contactos'
import Politicadatos from './components/politicadatos'
// import Whatsapp from './components/Whatsapp'

import './css/bootstrap.min.css';
import './css/App.css';
import './css/animate.min.css';

function App() {
  return (
    <div className="App">
      <div className="anclas" id="inicio"></div>
      <Menu />
      <Slide />
      <Nuevos />
      <Lineas />
      <div className="anclas" id="marcas"></div>
      <Marcas />
      <Promo />
      <div className="anclas" id="quienessomos"></div>
      <Quienessomos />
      <Misvis />
      <div className="anclas" id="sucursales"></div>
      <Mapa />
      <Locales />
      <Galeria />
      <div className="anclas" id="contactos"></div>
      <Contactos />
      {/*<div className="anclas" id="politicadatos"></div>}
      {/*<Politicadatos />}
      {/* <Whatsapp /> */}
    </div>
  );
}

export default App;
